webpackJsonp([18],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["default"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_delayed_render__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_polyfills__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_what_input__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_what_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_what_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_global_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_global_css__);
/* eslint-disable global-require, no-underscore-dangle */





/**
 * Initialize the client code.
 */
function init() {
  /**
   * Configure the third party tools like Sentry and Analytics
   * Do this now, so we can catch any errors with Sentry
   */

  /**
   * Load any polyfills that's required before rendering.
   */
  return Object(__WEBPACK_IMPORTED_MODULE_1__config_polyfills__["a" /* default */])().then(function () {
    /* We can now render components */
    return renderComponents();
  });
}

function renderComponents() {
  /**
   * If _components exists on the global object, render them out.
   * This will be server side components, that should be rendered once the app is ready.
   */
  if (global._components && Array.isArray(global._components)) {
    return Promise.all(Object(__WEBPACK_IMPORTED_MODULE_0__modules_delayed_render__["a" /* default */])(global._components)).catch(function (e) {
      // Error occured while rendering.
      // The delayedRender method has logged the error and rejected the promise. Carry on.
    }).then(function () {
      return componentsReady();
    });
  }

  return Promise.resolve();
}

function componentsReady() {
  if (false) {
    // On dev, disable the server bundle CSS file once the page is rendered.
    // Otherwise, you get duplicate CSS selectors for everything. 😨

    var clearServerCSS = function clearServerCSS() {
      document.querySelector('head > link[href="/static/css/server.render.css"]').setAttribute('disabled', 'true');
    };

    setTimeout(clearServerCSS, 1000);
  }
}

if (false) {
  /* Support hot reloading the routes */
  module.hot.accept('./modules/delayed-render', function () {
    var newRender = require('./modules/delayed-render').default;
    newRender(global._components);
  });
}

/* istanbul ignore next */
if (true) {
  // Init the client now - Moved inside init function to make it testable :)
  init();
}

/* istanbul ignore next */
// if (process.env.NODE_ENV=== 'production') {
//   // Install ServiceWorker in the end since
//   // it's not most important operation and if main code fails,
//   // we do not want it installed
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/static/scripts/sw.js')
//   }
//
//   // ServerWorker causing issues? Need to remove it?
//   // Replace the above register code with the unregister script below.
//   /*
//     if ('serviceWorker' in navigator) {
//       navigator.serviceWorker.getRegistrations().then((registrations) => {
//         registrations.forEach(registration => registration.unregister())
//       })
//     }
//   * */
// }
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(1);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./src/modules/modules-map.js
var modulesMap = null;

function getModules() {
  if (!modulesMap) {
    modulesMap = {};
    if (false) {
      var modules = require.context('./', true, /index\.js$/);

      modules.keys().forEach(function (name) {
        var moduleName = name.replace(/\.\/(\w+?)\/index.js$/, '$1');
        modulesMap[moduleName] = modules(name);
      });
    } else {
      var _modules = __webpack_require__(12);

      _modules.keys().forEach(function (name) {
        var moduleName = name.replace(/\.\/(\w+?)\/importer.js$/, '$1');
        modulesMap[moduleName] = _modules(name);
      });
    }
  }

  return modulesMap;
}

function getModule(name) {
  if (!name) return null;
  if (false) {
    // eslint-disable-next-line
    return require('./' + name + '/importer.js');
  }

  return getModules()[name];
}
// CONCATENATED MODULE: ./src/modules/delayed-render.js
/* harmony export (immutable) */ __webpack_exports__["a"] = delayedRender;
/* unused harmony export render */




/**
 * Call with list of server side rendered components when the app is ready.
 * Each component should contain the follow values: "name", "props" and "id".
 *
 * @param components {Array} List of components to render.
 */
function delayedRender(components) {
  return components.map(function (_ref) {
    var name = _ref.name,
        props = _ref.props,
        id = _ref.id,
        error = _ref.error;

    if (error) {
      var err = new Error(error);

      return Promise.reject(err);
    }
    var mod = getModule(name);
    if (mod) {
      /* Async import the required components when they are needed */
      return mod.default().then(function (module) {
        return render(module.default, props, id);
      })
      // eslint-disable-next-line no-console
      .catch(function (err) {
        return console.error(err, { name: name, props: props, id: id, components: components });
      });
    }

    return Promise.reject('[delayedRender] Module not found: ' + name);
  });
}

function render(component, props, id) {
  var el = document.getElementById(id);

  if (component && el) {
    react_dom_default.a.render(react_default.a.createElement(component, props), el);
  } else if (!el) {
    throw new Error('[delayedRender] Could not find element with id: \'' + id + '\'');
  } else {
    throw new Error('[delayedRender] Component not found for element with id: \'' + id + '\'');
  }
}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Aside/importer.js": 13,
	"./Button/importer.js": 16,
	"./ButtonGroup/importer.js": 17,
	"./Content/importer.js": 18,
	"./ContentRibbon/importer.js": 19,
	"./CookieBanner/importer.js": 20,
	"./Faq/importer.js": 21,
	"./FollowForm/importer.js": 22,
	"./Footer/importer.js": 23,
	"./Form/importer.js": 24,
	"./Hero/importer.js": 25,
	"./Menu/importer.js": 26,
	"./NemId/importer.js": 27,
	"./PreviewGrid/importer.js": 28,
	"./ProposalEditor/importer.js": 29,
	"./RegisterForm/importer.js": 30,
	"./StepIndicator/importer.js": 31,
	"./SupportsForm/importer.js": 32
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(1)]).then((function (require) {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(14)]).then((function (require) {
      resolve(__webpack_require__(40));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(17)]).then((function (require) {
      resolve(__webpack_require__(41));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(13)]).then((function (require) {
      resolve(__webpack_require__(42));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
// export default () => import('./index')

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(4)]).then((function (require) {
      resolve(__webpack_require__(43));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(16)]).then((function (require) {
      resolve(__webpack_require__(44));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(12)]).then((function (require) {
      resolve(__webpack_require__(45));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(11)]).then((function (require) {
      resolve(__webpack_require__(46));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(1)]).then((function (require) {
      resolve(__webpack_require__(47));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(5)]).then((function (require) {
      resolve(__webpack_require__(48));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(6)]).then((function (require) {
      resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(7)]).then((function (require) {
      resolve(__webpack_require__(50));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(3)]).then((function (require) {
      resolve(__webpack_require__(51));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(2)]).then((function (require) {
      resolve(__webpack_require__(52));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(8)]).then((function (require) {
      resolve(__webpack_require__(53));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(10)]).then((function (require) {
      resolve(__webpack_require__(54));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
/* harmony default export */ __webpack_exports__["default"] = (function () {
  return new Promise(function (resolve) {
    Promise.all/* require.ensure */([__webpack_require__.e(0), __webpack_require__.e(9)]).then((function (require) {
      resolve(__webpack_require__(55));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  });
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Load additional polyfills here
 **/
function loadPolyfills() {
  var polyfills = [];

  if (!supportsIntersectionObserver()) {
    polyfills.push(new Promise(function (resolve) {
      __webpack_require__.e/* require.ensure */(15).then((function (require) {
        resolve(__webpack_require__(56));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }));
  }

  return Promise.all(polyfills);
}

function supportsIntersectionObserver() {
  return 'IntersectionObserver' in global && 'IntersectionObserverEntry' in global && 'intersectionRatio' in IntersectionObserverEntry.prototype;
}

/* harmony default export */ __webpack_exports__["a"] = (loadPolyfills);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v4.3.1
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * variables
	   */

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = null;

	  // cache document.documentElement
	  var doc = document.documentElement;

	  // form input types
	  var formInputs = ['input', 'select', 'textarea'];

	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  // list of keys for which we change intent even for form inputs
	  var changeIntentMap = [9 // tab
	  ];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch'
	  };

	  // array of all used input types
	  var inputTypes = [];

	  // boolean: true if touch buffer is active
	  var isBuffering = false;

	  // boolean: true if the page is being scrolled
	  var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null
	  };

	  // map of IE 10 pointer events
	  var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'
	  };

	  var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}

	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	    setInput();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true } : false;

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      doc.addEventListener('pointerdown', updateInput);
	      doc.addEventListener('pointermove', setIntent);
	    } else if (window.MSPointerEvent) {
	      doc.addEventListener('MSPointerDown', updateInput);
	      doc.addEventListener('MSPointerMove', setIntent);
	    } else {
	      // mouse events
	      doc.addEventListener('mousedown', updateInput);
	      doc.addEventListener('mousemove', setIntent);

	      // touch events
	      if ('ontouchstart' in window) {
	        doc.addEventListener('touchstart', touchBuffer, options);
	        doc.addEventListener('touchend', touchBuffer);
	      }
	    }

	    // mouse wheel
	    doc.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    doc.addEventListener('keydown', updateInput);
	    doc.addEventListener('keyup', updateInput);
	  };

	  // checks conditions before updating new input
	  var updateInput = function updateInput(event) {
	    // only execute if the touch buffer timer isn't running
	    if (!isBuffering) {
	      var eventKey = event.which;
	      var value = inputMap[event.type];
	      if (value === 'pointer') value = pointerType(event);

	      if (currentInput !== value || currentIntent !== value) {
	        var activeElem = document.activeElement;
	        var activeInput = false;
	        var notFormInput = activeElem && activeElem.nodeName && formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1;

	        if (notFormInput || changeIntentMap.indexOf(eventKey) !== -1) {
	          activeInput = true;
	        }

	        if (value === 'touch' ||
	        // ignore mouse modifier keys
	        value === 'mouse' ||
	        // don't switch if the current element is a form input
	        value === 'keyboard' && eventKey && activeInput && ignoreMap.indexOf(eventKey) === -1) {
	          // set the current and catch-all variable
	          currentInput = currentIntent = value;

	          setInput();
	        }
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var setInput = function setInput() {
	    doc.setAttribute('data-whatinput', currentInput);
	    doc.setAttribute('data-whatintent', currentInput);

	    if (inputTypes.indexOf(currentInput) === -1) {
	      inputTypes.push(currentInput);
	      doc.className += ' whatinput-types-' + currentInput;
	    }

	    fireFunctions('input');
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    // test to see if `mousemove` happened relative to the screen
	    // to detect scrolling versus mousemove
	    if (mousePos['x'] !== event.screenX || mousePos['y'] !== event.screenY) {
	      isScrolling = false;

	      mousePos['x'] = event.screenX;
	      mousePos['y'] = event.screenY;
	    } else {
	      isScrolling = true;
	    }

	    // only execute if the touch buffer timer isn't running
	    // or scrolling isn't happening
	    if (!isBuffering && !isScrolling) {
	      var value = inputMap[event.type];
	      if (value === 'pointer') value = pointerType(event);

	      if (currentIntent !== value) {
	        currentIntent = value;

	        doc.setAttribute('data-whatintent', currentIntent);

	        fireFunctions('intent');
	      }
	    }
	  };

	  // buffers touch events because they frequently also fire mouse events
	  var touchBuffer = function touchBuffer(event) {
	    if (event.type === 'touchstart') {
	      isBuffering = false;

	      // set the current input
	      updateInput(event);
	    } else {
	      isBuffering = true;
	    }
	  };

	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, currentIntent);
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	  var detectWheel = function detectWheel() {
	    var wheelType = void 0;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'loose'|'strict'
	    // 'strict' (default): returns the same value as the `data-whatinput` attribute
	    // 'loose': includes `data-whatintent` value if it's more current than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'loose' ? currentIntent : currentInput;
	    },

	    // returns array: all the detected input types
	    types: function types() {
	      return inputTypes;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position) {
	        functionList.splice(position, 1);
	      }
	    }
	  };
	}();

/***/ }
/******/ ])
});
;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/scripts/client-ef91c11eaf4324ba4db2.js